export default "__VITE_ASSET__D6YC4eL9__"